import React from 'react';
import Griddle, { plugins } from 'griddle-react';

export const styleConfig = {
  icons: {
    TableHeadingCell: {
      sortDescendingIcon: '▼',
      sortAscendingIcon: '▲',
    },
  },
  classNames: {
    Row: 'row-class',
    Table: 'table-striped table',
    NextButton: 'btn btn-sm btn-success',
    PreviousButton:'btn btn-sm btn-success' 
  },
  styles: {
    Filter: { fontSize: 18 },
  },
};
class StyledGriddle extends React.Component {
  render() {
    return (
      <Griddle
        {...this.props}
        plugins={[plugins.LocalPlugin]}
        styleConfig={styleConfig}
        components={{
          Filter: () => <span />,
          SettingsToggle: () => <span />,
        }}
      >
        {this.props.children}
      </Griddle>
    );
  }
}

export default StyledGriddle;



// WEBPACK FOOTER //
// src/components/StyledGriddle/StyledGriddle.js